module.exports = __webpack_public_path__ + "img/avatar.9ac344e4.png";